const InvitationOptions = ({
  loading,
  buttonRef,
  isDropdownOpen,
  setIsDropdownOpen,
  optionsRef,
  formData,
  setFormData,
}) => {
  return (
    <div className="z-2">
      {loading ? (
        <button
          type="button"
          className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none shadow-lg  :outline-none  :ring-1  :ring-gray-600"
        >
          Slanje
          <span
            className="animate-spin inline-block size-4 border-[3px] border-current border-t-transparent text-white rounded-full"
            role="status"
            aria-label="loading"
          ></span>
        </button>
      ) : (
        <div className="relative inline-block text-left">
          <button
            ref={buttonRef}
            type="button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="w-7 h-7 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none shadow-lg  :outline-none  :ring-1  :ring-gray-600"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
            </svg>
          </button>

          {isDropdownOpen && (
            <div
              ref={optionsRef}
              className="absolute transform -translate-x-36 mb-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 z-[999]"
            >
              <div className="py-1">
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      includeEmblem: !prev.includeEmblem,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.includeEmblem ? "Ukloni" : "Dodaj"} pečat
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      timelineWithQuote: !prev.timelineWithQuote,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.timelineWithQuote ? "Ukloni" : "Dodaj"} vremensku
                  crtu
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      includeMap: !prev.includeMap,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.includeMap ? "Ukloni" : "Dodaj"} kartu
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      countdown: !prev.countdown,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.countdown ? "Ukloni" : "Dodaj"} odbrojavanje
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      includeMessageToGuests: !prev.includeMessageToGuests,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.includeMessageToGuests ? "Ukloni" : "Dodaj"}{" "}
                  obavijest gostima
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      includePhone: !prev.includePhone,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.includePhone ? "Ukloni" : "Dodaj"} telefon polje
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      includeEmail: !prev.includeEmail,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.includeEmail ? "Ukloni" : "Dodaj"} email polje
                </button>
                <button
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      formAccommodation: !prev.formAccommodation,
                    }));
                    setIsDropdownOpen(false);
                  }}
                  className="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 w-full text-left"
                >
                  {formData.formAccommodation ? "Ukloni" : "Dodaj"} ponudu
                  smještaja{" "}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InvitationOptions;
